module.exports = __webpack_public_path__ + "static/media/vizio-header-logo.2292c92f.png";